import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  background-color: white;
  display: flex;
  height: 52px;
  flex: none;
  gap: 18px;
  justify-content: center;
`;
